//
// InteractionEvent.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/events/PortableEvent";
import "../visualElements/VisualElementController";
import "../../models/visualElements/actions/AbstractAction";
import "../../models/view/Section";

var InteractionEvent = createModule("BIRD::InteractionEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        FILTER: 50020,
        ACTION: 50019,
        POP_ACTION: 50018,
    },
    ,
    ,
    ,
    {
        getResolvedURL: [7],
        getSourceSectionIndex: [4],
        getSourceSection: [1],
        getSourceSectionName: [7],
        getSourceController: [1],
        getFilterExpressionDescriptions: [[7],1],
        getAction: [1],
        getDataResourceNames: [[7]],
        getSourceSectionLabel: [7],
    },
    ,
    ,
]);
export default InteractionEvent;
